import { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { MsalProvider } from "@azure/msal-react";
import { PublicClientApplication } from "@azure/msal-browser";
import msalConfig from './Config/msalConfig';
import App from './App/App';
import Loading from './Layout/Loading';
import './index.css';
import './Config/i18n'; // import i18n (needs to be bundled ;))
import 'moment/locale/fi';

const pca = new PublicClientApplication(msalConfig);

ReactDOM.render(
    <Suspense fallback={<Loading />}>
        {/*<React.StrictMode>*/}
        <MsalProvider instance={pca}>
            <App />
        </MsalProvider>
        {/*</React.StrictMode>*/}
    </Suspense>,
    document.getElementById('root')
);